export default __webpack_public_path__ + "static/media/background2.ab1d8eaf.jpeg";